
<div class="loader-screen">
  <div class="loader-container">

    <!-- AI Loader -->
    <div class="loader-orbit">
      <div class="loader-ring"></div>
      <div class="loader-ring loader-ring-inner"></div>

      <div class="loader-core">
        <i class="bi bi-stars"></i>
      </div>

      <span class="orbit-dot dot-one"></span>
      <span class="orbit-dot dot-two"></span>
    </div>

    <!-- Loader Text -->
    <div class="loader-text">
      <h6>Loading</h6>
      <p>Please wait while we process your request</p>
    </div>

    <!-- Progress -->
    <div class="loader-progress">
      <span></span>
    </div>
  </div>
</div>
